var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("div", { staticClass: "custom-download-buttons" }, [
        _c(
          "button",
          {
            staticClass: "download-btn postman-btn",
            attrs: { disabled: _vm.isLoading },
            on: { click: _vm.downloadPostman }
          },
          [
            _vm.isLoading
              ? _c("span", { staticClass: "loading-spinner" })
              : _vm._e(),
            _vm._v(
              " " +
                _vm._s(
                  _vm.isLoading ? "Baixando..." : "Download Postman.json"
                ) +
                " "
            )
          ]
        )
      ]),
      _c("redoc-wrapper", {
        attrs: { "spec-or-spec-url": _vm.json, options: _vm.redocOptions }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }